module.exports = __webpack_public_path__ + "static/media/malaysia.a6a2a3d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/malaysia.jpg
// module id = 40
// module chunks = 0